/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * standard header for the title of a card
 */
export class WrcCardHeader extends React.PureComponent {
    render() {
        if(this.props.small){
            return(<h4 className="bp3-heading">{this.props.title}</h4>);
        }
        return(<h3 className="bp3-heading">{this.props.title}</h3>);
    }
}

WrcCardHeader.propTypes = {
    title: PropTypes.node.isRequired,
    small: PropTypes.bool
};
